<template>
    <div>
        <div class="form-container">
            <div class="row justify-content-md-center">
                <div class="col-sm">
                    <div class="mb-3">
                        <InputField
                            :customErrorMessage="$t('form.fields.nationalId.errorMessage')"
                            :validationRules="validationRulesNationalId"
                            :label="$t('form.fields.nationalId.label')"
                            name="nationalId"
                            ref="nationalId"
                            type="tel"
                        />
                    </div>

                    <InputField
                        :customErrorMessage="$t('form.fields.idcNo.errorMessage')"
                        :validationRules="validationRulesIdcNo"
                        :label="$t('form.fields.idcNo.label')"
                        name="idcNo"
                        type="text"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    // static settings to initialize step (not reactive inside this file!)
    stepDefinition() {
        return {
            name: 'pesel',
            route: {
                relativeUrl: `pesel`,
                name: 'apply.pesel',
                meta: {
                    title: 'form.sections.aboutYou.nationalId.heading',
                    tooltip: 'form.sections.aboutYou.nationalId.tooltip',
                    tooltipType: 'small',
                },
            },
            fields: {
                idcNo: {
                    value: null,
                    mappedKey: 'identity_card_no',
                    validationRules: {
                        required: true,
                        polishIdentityCard: true,
                        min: 9,
                        max: 9,
                    },
                    hideOnSummary: true,
                    ignorePrepopulation: true,
                },
                nationalId: {
                    value: null,
                    mappedKey: 'national_id',
                    validationRules: {
                        required: true,
                        digits: 11,
                        pesel: true,
                    },
                    hideOnSummary: true,
                    ignorePrepopulation: true,
                },
            },
        }
    },

    mounted() {
        this.autoFocus(this.$refs.nationalId)
    },

    created() {
        this.emitter.emit('stepLoaded')
    },

    computed: {
        validationRulesNationalId: function () {
            return this.$store.getters.fieldValidationRules('nationalId')
        },
        validationRulesIdcNo: function () {
            return this.$store.getters.fieldValidationRules('idcNo')
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';

.block {
    text-align: left;
    position: relative;
    background: #f4f5f6;
    padding: 26px 24px 24px 95px;
    margin: 20px 0;
    font-size: rem(14px);
    color: #525252;

    h2 {
        font-size: rem(18px);
        font-weight: bold;
        margin-bottom: 20px;
        color: #242a2f;
    }

    .icon {
        position: absolute;
        left: 24px;
        top: 26px;
        font-size: rem(18px);
        background: #3380e3;
        color: #fff;
        padding: 10px;
        border-radius: 50%;
    }

    .checkbox-row {
        padding-top: 20px;
        font-weight: bold;
        color: #242a2f;
    }
}
</style>
